var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u0421\\u043B\\u043E\\u0439_2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19.08 23.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #afb1b3;\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u0421\\u043B\\u043E\\u0439_1-2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.54,23.48c-.66,0-1.31-.14-1.92-.43C2.67,20.74,0,14.44,0,9.7,0,4.35,4.28,0,9.54,0s9.54,4.35,9.54,9.7c0,4.75-2.67,11.04-7.62,13.35-.61.29-1.27.43-1.93.43ZM9.54,1.5C5.11,1.5,1.5,5.18,1.5,9.7c0,4.28,2.37,9.94,6.75,11.99.82.38,1.76.38,2.58,0,3.85-1.8,6.75-6.95,6.75-11.99,0-4.52-3.61-8.2-8.04-8.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.54,13.59c-2.23,0-4.05-1.82-4.05-4.05s1.82-4.05,4.05-4.05,4.05,1.82,4.05,4.05-1.82,4.05-4.05,4.05ZM9.54,6.99c-1.4,0-2.55,1.14-2.55,2.55s1.14,2.55,2.55,2.55,2.55-1.14,2.55-2.55-1.14-2.55-2.55-2.55Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPin);
export default __webpack_public_path__ + "static/media/mapPin.dcb8baa81428db9fc44a9741d2809858.svg";
export { ForwardRef as ReactComponent };